module.exports = __webpack_public_path__ + "static/media/aam-accomplishments.c0e76bb9.jpg";